export class PredictiveSearch {
  constructor() {
    this.selectors = {
      searchTriggers: ".predictive-search-container .search-trigger",
      resultsWrapper: ".predictive-search-container",
      resultsInner: ".predictive-search-container .inner.predictive-inner",
      closeButton: ".predictive-search-container .close",
      recommendedInner: ".predictive-search-container .inner.recommended-inner",
      recommendedSwiper: ".predictive-search-container .inner.recommended-inner .swiper.search-recommendations-swiper",
      recentPlaceholder: ".predictive-search-container .inner.recommended-inner .sidebar-group.recent-searches",
      recentContainer:
        ".predictive-search-container .inner.recommended-inner .sidebar-group.recent-searches .recent-search-container",
      searchBar: ".predictive-search-container .search-bar-qf .search-trigger",
      headerOpenSearch: ".mega-menu .header-search[data-open-search]",
      closeMobileMenu: ".mega-menu .mobile-menu-wrapper .menu-close-btn",
    };

    this.sectionId = "pg-predictive-search";
    this.init();
  }

  init() {
    const { searchTriggers, closeButton, closeMobileMenu } = this.selectors;

    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
      };
    };

    document.querySelectorAll(searchTriggers).forEach((searchBar) => {
      searchBar.addEventListener(
        "keyup",
        debounce(() => this.handleSearch(searchBar.value), 330)
      );
      searchBar.addEventListener("focus", () => this.openResults());
    });

    document.querySelector(closeButton)?.addEventListener("click", () => this.closeResults());
    document.querySelector(closeMobileMenu)?.addEventListener("click", () => this.closeResults());

    this.getRecentSearches();
    this.initRecommendedProductsSwiper();
  }

  openResults() {
    document.querySelector(this.selectors.resultsWrapper).classList.add("active");

    const searchInstance = Tagalys.APIConnector.SearchSuggestions.new({
      params: {
        request: {
          collections: { limit: 10 },
        },
      },
      onSuccess: (response) => {
        console.log(response);
      },
      onFailure: (error) => {
        console.log(error);
      },
    });

    const desiredCount = 5;

    const popularWrap = document.querySelector('.sidebar-group[popular-searches]');
    const exclusions = (popularWrap?.dataset.exclusions || '')
      .split(',')
      .map(s => s.trim().toLowerCase())
      .filter(Boolean); // remove empties

    const isAllowed = (term) => {
      const label = String(term.displayString || '').trim().toLowerCase();
      return !exclusions.includes(label);
    };

    searchInstance.helpers.getPopularSearches(20).then((response) => {
      if (!response || !popularWrap) return;

      document.querySelector('.sidebar-group[collections]')?.remove();

      const filtered = response.filter(isAllowed).slice(0, desiredCount);

      const content = popularWrap.querySelector('.content');
      if (!content) return;
      content.innerHTML = '';

      const frag = document.createDocumentFragment();
      filtered.forEach(term => {
        const a = document.createElement('a');
        a.className = 'link';
        a.href = `/search?${term.queryString}`;
        a.textContent = term.displayString;
        frag.appendChild(a);
      });

      content.appendChild(frag);
    });

  }

  closeResults() {
    const resultsWrapper = document.querySelector(this.selectors.resultsWrapper);
    const resultsInner = document.querySelector(this.selectors.resultsInner);
    const recommendedInner = document.querySelector(this.selectors.recommendedInner);
    const searchBar = document.querySelector(this.selectors.searchBar);

    resultsInner.innerHTML = "";
    resultsInner.style.display = "none";
    recommendedInner.style.display = "flex";

    resultsWrapper.classList.remove("active");
    searchBar.classList.remove("active");
  }

  handleSearch(query) {
    if (query.length <= 2) {
      this.handleNoResults();
      return;
    }

    // 1) Try Tagalys if available
    if (window.Tagalys && Tagalys.APIConnector) {
      this.fetchTagalysResults(query)
        .then(async (results) => {
          if (results && (results.products?.length || results.collections?.length || results.pages?.length)) {
            console.log("Tagalys Results: ",results);

            const handles = {
              products: results.products?.map((p) => p.handle) || [],
              collections: results.collections?.map((c) => {
                const match = c.link.match(/\/collections\/([^/?#]+)/);
                return match ? match[1] : null;
            }) || [],
              pages: results.pages?.map((p) => encodeURIComponent(p.displayString + p.link.replace(/^https?:\/\/[^/]+/, ""))) || [],
            };
            const url =
              `${window.Shopify.routes.root}search/suggest?` +
              `tagalys_handles=${handles?.products.join(",")}` +
              `&tagalys_collection_handles=${handles?.collections.join(",")}` +
              `&tagalys_page_handles=${handles?.pages.join(",")}` +
              `&q=${encodeURIComponent(query)}` +
              `&resources[type]=product,collection,article,page` +
              `&resources[options][fields]=title,body,product_type,variants.title,tag` +
              `&resources[limit_scope]=each` +
              `&section_id=${this.sectionId}`;

            const res = await fetch(url);

            console.log("Result: ",res);

            return await res.text();
          }else {
            return this.fetchShopifyPredictive(query);
          }
        })
        .then((htmlOrUndefined) => {
            // console.log("HTML ORDER",htmlOrUndefined);

          if (typeof htmlOrUndefined === "string") {
            this.renderResults(htmlOrUndefined);
          }
        })
        .catch((err) => {
          console.error("Tagalys error:", err);
          this.fetchShopifyPredictive(query);
        });
    } else {
      this.fetchShopifyPredictive(query);
    }
  }

  fetchTagalysResults(query) {
    return new Promise((resolve, reject) => {
      const searchInstance = Tagalys.APIConnector.SearchSuggestions.new({
        params: {
          query,
          request: {
            collections: { limit: 10 },
            pages: { limit: 10 },
            products: { limit: 16 },
          },
        },
        onSuccess: (response) => {
          if (response) {
            const results = {
              products: response.products || [],
              collections: response.queries?.find((q) => q.section_id === "collections")?.items || [],
              pages: response.queries?.find((q) => q.section_id === "pages")?.items || [],
            };
            resolve(results);
          } else {
            resolve({});
          }
        },
        onFailure: (error) => reject(error),
      });
      searchInstance.helpers.call();
      searchInstance.helpers.getPopularSearches(10).then(function(response) {
        console.log(response);
      });
    });
  }

  async fetchShopifyPredictive(query) {
    // search/suggest?q=${ query }&resources[type]=product,collection,article,page&resources[options][fields]=title,body,product_type,variants.title,tag&resources[limit_scope]=each&section_id=${ this.sectionId }
    const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(
      query
    )}&resources[type]=product,collection,article,page&resources[options][fields]=title,body,product_type,variants.title,tag&resources[limit_scope]=each&section_id=${this.sectionId}`;
    try {
      const res = await fetch(url);
      const html = await res.text();
      this.renderResults(html);
    } catch (err) {
      console.error("Shopify predictive failed:", err);
      this.handleNoResults();
    }
  }

  renderResults(html) {
    const resultsInner = document.querySelector(this.selectors.resultsInner);
    const recommendedInner = document.querySelector(this.selectors.recommendedInner);

    this.openResults();
    resultsInner.style.display = "flex";
    recommendedInner.style.display = "none";
    resultsInner.innerHTML = html;
    resultsInner.querySelector("#shopify-section-pg-predictive-search").style.width = "100%";
  }

  handleNoResults() {
    const resultsInner = document.querySelector(this.selectors.resultsInner);
    const recommendedInner = document.querySelector(this.selectors.recommendedInner);

    resultsInner.innerHTML = "";
    resultsInner.style.display = "none";
    recommendedInner.style.display = "flex";
  }

  initRecommendedProductsSwiper() {
    const swiper_recommended_el = document.querySelector(this.selectors.recommendedSwiper);
    if (swiper_recommended_el) {
      const swiper_recommended = new window.swiper(this.selectors.recommendedSwiper, {
        slidesPerView: 2.5,
        spaceBetween: 10,
        breakpoints: {
          450: { slidesPerView: 3 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
        },
      });
    }
  }

  getRecentSearches() {
    const recentPlaceholder = document.querySelector(this.selectors.recentPlaceholder);
    if (!recentPlaceholder) return;

    const recentContainer = recentPlaceholder.querySelector(this.selectors.recentContainer);
    if (!recentContainer) return;

    const RECENT_SEARCHES_LOCAL_KEY = window.Shopify.shop.replace(/.myshopify.com/g, "") + "__recentSearches";
    const RECENT_SEARCHES_LOCAL = JSON.parse(localStorage.getItem(RECENT_SEARCHES_LOCAL_KEY));

    if (RECENT_SEARCHES_LOCAL && RECENT_SEARCHES_LOCAL.length > 0) {
      const recentArrReverse = RECENT_SEARCHES_LOCAL.reverse();
      const recentSearchFragment = document.createDocumentFragment();

      recentArrReverse.forEach((searchTerm) => {
        const searchLink = "/search?q=" + searchTerm + "&type=product";
        const linkNode = document.createElement("a");
        linkNode.setAttribute("href", searchLink);
        linkNode.textContent = searchTerm;
        linkNode.classList.add("link");
        recentSearchFragment.appendChild(linkNode);
      });

      recentContainer.appendChild(recentSearchFragment);
    } else {
      recentPlaceholder.remove();
    }
  }
}
